<template>
  <div>
    <div class="mt-4">
      <h4 class="text-left pl-3 pt-3 auction-title">E-Bids & E-Auction</h4>
      <div v-if="showDatePicker" class="col-8 mt-3 float-right">
        <date-picker
          v-model="selectedDateRange"
          range
          :lang="'en'"
          confirm
          @confirm="getEAuctionDate($event, i)"
          :format="'D-MMM-YYYY'"
          :shortcuts="false"
          :not-after="disableDateAfter"
          :not-before="disableDateBefore"
          class="drop-down p-0 mb-n5 m-0 float-right"
        ></date-picker>
      </div>

      <b-tabs class="request-navbar mt-3 pb-5" small card>
        <!-- <b-tab class="tab_style" active>
          <template slot="title">
            <span class="p-0 m-0 tab_style">For Auction</span>
            <b-badge pill class="selected-number-list px-2 py-0" variant="info">
              <span>0</span>
            </b-badge>
          </template>
          <div>
            <h4>No Record Available</h4>
          </div>
        </b-tab>-->
        <b-tab @click="tabStatus('showDate')" class="tab_style">
          <template slot="title">
            <span class="p-0 m-0 tab_style">In Progress</span>
            <b-badge pill class="selected-number-list px-2 py-0" variant="info">
              <span>0</span>
            </b-badge>
          </template>
          <div class="row p-0 m-0">
            <div class="col-xl-6">
              <p class="p-0 m-0 pt-1 float-left text-heading">E-Bid</p>
              <div
                class="col-md-6 col-lg-3"
                style="position: absolute; right: 10px"
              >
                <select
                  v-model="filtersselectedBid"
                  class="form-control"
                  @change="ChangelogBid(filtersselectedBid)"
                >
                  <option
                    :key="i"
                    v-for="(options, i) in option"
                    v-bind:value="options.value"
                  >
                    {{ options.text }}
                  </option>
                </select>
              </div>
              <br />
              <div class="p-0 m-0 Ebid-card mt-3">
                <w-ebid-table
                  :tableLoading="showTableLoding"
                  :tableValue="ebidDataTable"
                  :bidType="'Bid'"
                  @viewDetails="redirectionPage($event)"
                />
              </div>
            </div>
            <div class="col-xl-6">
              <p class="p-0 m-0 pt-1 float-left text-heading">E-Auction</p>
              <div
                class="col-md-6 col-lg-3"
                style="position: absolute; right: 10px"
              >
                <select
                  v-model="filtersselectedAUC"
                  class="form-control"
                  @change="ChangelogAuc(filtersselectedAUC)"
                >
                  <option
                    :key="i"
                    v-for="(options, i) in option"
                    v-bind:value="options.value"
                  >
                    {{ options.text }}
                  </option>
                </select>
              </div>
              <br />

              <div class="p-0 m-0 Ebid-card mt-3">
                <w-ebid-table
                  :tableLoading="showTableLoding"
                  :tableValue="eAuctionTable"
                  :bidType="'Auction'"
                  @viewDetails="redirectionPage($event)"
                />
              </div>
            </div>

            <!-- <div class="row mb-5 mx-3"> 
              <div class="col Auction">
                <b-card header-tag="header" class="performance-card" footer-tag="footer">
                  <template v-slot:header>
                    <span class="p-0 m-0 pt-1 float-left text-heading">E-Bid</span>
                    <date-picker
                      v-model="selectedDateRange"
                      range
                      :lang="'en'"
                      confirm
                      @confirm="getEbidAuctionDate($event)"
                      :format="'D-MMM-YYYY'"
                      :shortcuts="false"
                      :not-after="disableDateAfter"
                      :not-before="disableDateBefore"
                      class="drop-down col-4 p-0 m-0 float-right"
                    ></date-picker>
                  </template>
                  <div>
                    <w-ebid-table
                      :tableLoading="showTableLoding"
                      :tableValue="ebidDataTable"
                      @viewDetails="redirectionPage($event)"
                    />
                  </div>
                </b-card>
              </div>
              <div class="col Auction">
                <b-card header-tag="header" class="performance-card" footer-tag="footer">
                  <template v-slot:header>
                    <span class="p-0 m-0 pt-1 float-left text-heading">E-Auction</span>
                    <date-picker
                      v-model="selectedDateRange"
                      range
                      :lang="'en'"
                      confirm
                      @confirm="getEAuctionDate($event,i)"
                      :format="'D-MMM-YYYY'"
                      :shortcuts="false"
                      :not-after="disableDateAfter"
                      :not-before="disableDateBefore"
                      class="drop-down col-4 p-0 m-0 float-right"
                    ></date-picker>
                  </template>
                  <div>
                    <w-ebid-table
                      :tableLoading="showTableLoding"
                      :tableValue="eAuctionTable"
                      @viewDetails="redirectionPage($event)"
                    />
                  </div>
                </b-card>
              </div>
            </div>-->
          </div>
        </b-tab>
        <b-tab @click="tabStatus()" class="tab_style">
          <template slot="title">
            <span class="p-0 m-0 tab_style">Awarded</span>
            <b-badge pill class="selected-number-list px-2 py-0" variant="info">
              <span>0</span>
            </b-badge>
          </template>
          <div>
            <h4>No Record Available</h4>
          </div>
        </b-tab>
        <!-- <b-tab class="tab_style">
          <template slot="title">
            <span class="p-0 m-0 tab_style">All</span>
            <b-badge pill class="selected-number-list px-2 py-0" variant="info">
              <span>0</span>
            </b-badge>
          </template>
          <div>
            <h4>No Record Available</h4>
          </div>
        </b-tab>-->
      </b-tabs>
    </div>
  </div>
</template>


<script>
import moment from "moment";
import countDown from "../../widgets/countdowntimer";

import LoadingSpinner from "../../widgets/LoadingSpinner";
import { PartnerService } from "../../services/partnerService";
import widgetModal from "../../widgets/newModalWidget";
import ebidTable from "../../widgets/ebidtable";
const partnerService = new PartnerService();
import dropDown from "../../widgets/DropDown";
import DatePicker from "vue2-datepicker";

export default {
  components: {
    "w-countdown": countDown,
    "w-ebid-table": ebidTable,
    "w-dropdown": dropDown,
    DatePicker,
  },
  created() {
    partnerService.getPartnerInfo().then((resp) => {
      this.companycode = resp.response.currentCompanyCode;
      this.$root.isInternational =
        resp.response.countryDetail.countryCode == 100 ? false : true;
      this.partnerNumber = resp.response.partnerNumber;
      this.getEBIDDetails(this.companycode);
    });
    var self = this;
    EventBus.$on("switchCompany", function (e) {
      window.alert(self.$router.currentRoute);
      console.log(self.$router.currentRoute);
      partnerService.getPartnerInfo().then((resp) => {
        self.companycode = resp.response.currentCompanyCode;
        this.$root.isInternational =
          resp.response.countryDetail.countryCode == 100 ? false : true;
        self.partnerNumber = resp.response.partnerNumber;
        self.getEBIDDetails(self.companycode);
      });
    });
  },
  watch: {},

  data() {
    return {
      ebidData: [],
      showDetails: Boolean,
      showTableLoding: false,
      filtersselectedBid: "Live",
      filtersselectedAUC: "Live",
      showDatePicker: true,
      getLiveEbidData: [],
      getLiveAuctionData: [],
      referenceEbidData: [],
      referenceAuctionData: [],
      selectedDateRange: [],
      disableDateAfter: "",
      disableDateBefore: "",
      partnerNumber: "",
      partnerCodeValue: [],
      filterOptions: [
        { value: null, text: "Select Period", disabled: true },
        { value: 1, text: "Previous Month" },
        { value: 2, text: "Previous 3 Month" },
      ],
      option: [
        { text: "All", value: "All" },
        { text: "Live", value: "Live" },
        { text: "Expired", value: "Expired" },
        { text: "Upcoming", value: "Upcoming" },
      ],

      ebidDataTable: {
        fields: [
          {
            key: "documentNo",
            label: "Bid Number",
            thClass: "thClassLeft",
            tdClass: "text-left",
          },
          {
            key: "scope",
            label: "Description",
            thClass: "thClassLeft",
            tdClass: "text-left",
          },
          // {
          //   key: "status",
          //   label: "Status",
          //   thClass: "thClassLeft",
          //   tdClass: "text-left"
          // },
          {
            key: "startDate",
            label: "Status",
            thClass: "thClassLeft",
            tdClass: "text-left",
          },
          {
            key: "endDate",
            label: "",
            thClass: "thClassLeft",
            tdClass: "text-left",
          },
        ],
        items: [],
      },
      eAuctionTable: {
        fields: [
          {
            key: "documentNo",
            label: "Auction Number",
            thClass: "thClassLeft",
            tdClass: "text-left",
          },
          {
            key: "scope",
            label: "Description",
            thClass: "thClassLeft",
            tdClass: "text-left",
          },
          // {
          //   key: "status",
          //   label: "Status",
          //   thClass: "thClassLeft",
          //   tdClass: "text-left"
          // },
          {
            key: "startDate",
            label: "Status",
            thClass: "thClassLeft",
            tdClass: "text-left",
          },
          {
            key: "endDate",
            label: "",
            thClass: "thClassLeft",
            tdClass: "text-left",
          },
        ],
        items: [],
      },
    };
  },
  methods: {
    getLiveDataBidAuc() {
      this.ebidDataTable.items = this.getLiveEbidData.filter(
        (x) => this.isviewable(x).toLowerCase() == "Live".toLowerCase()
      );

      this.eAuctionTable.items = this.getLiveAuctionData.filter(
        (x) => this.isviewable(x).toLowerCase() == "Live".toLowerCase()
      );
    },
    isviewable(item) {
      var start = item.startDate;
      var end = item.endDate;
      if (new Date(end) < new Date()) {
        return "Expired";
      } else if (new Date(start) <= new Date() && new Date(end) >= new Date()) {
        return "Live";
      } else if (new Date(start) > new Date()) {
        return "Upcoming";
      }
    },
    ChangelogBid(status) {
      if (status == "All") {
        this.ebidDataTable.items = this.referenceEbidData;
      } else {
        this.ebidDataTable.items = this.referenceEbidData.filter(
          (x) => this.isviewable(x).toLowerCase() == status.toLowerCase()
        );
      }
    },
    ChangelogAuc(status) {
      if (status == "All") {
        this.eAuctionTable.items = this.referenceAuctionData;
      } else {
        this.eAuctionTable.items = this.referenceAuctionData.filter(
          (x) => this.isviewable(x).toLowerCase() == status.toLowerCase()
        );
      }
    },

    getEbidAuctionDate(event) {
      this.getEbidAuction(event[0], event[1]);
    },
    tabStatus(status) {
      console.log(status);
      if (status == "showDate") {
        this.showDatePicker = true;
      } else {
        this.showDatePicker = false;
      }
    },
    getEAuctionDate(event) {
      this.getEbidAuction(event[0], event[1]);
    },
    getEbidAuction(fromDate, toDate) {
      this.showTableLoding = true;
      var data = {};
      data.uid = "1";
      data.type = "Public";
      var partner = [];
      this.partnerCodeValue.forEach((item) => {
        partner.push(item.value);
      });
      data.partnerCode = partner;
      data.startDate = fromDate;
      data.endDate = toDate;
      data.companyCode = this.companycode;
      partnerService.getEbid(data).then((resp) => {
        this.ebidData = resp.response;
        this.ebidDataTable.items = resp.response.ebid;
        this.eAuctionTable.items = resp.response.eauction;
        this.getLiveEbidData = this.ebidDataTable.items;
        this.getLiveAuctionData = this.eAuctionTable.items;
        this.referenceEbidData = this.ebidDataTable.items;
        this.referenceAuctionData = this.eAuctionTable.items;
        this.getLiveDataBidAuc();
        this.showTableLoding = false;
      });
      // this.tableLoading = false;
    },
    getSelectedFilter() {},
    bidTypes(value) {
      console.log(value);
      return value;
    },
    viewDetails() {
      this.showDetails = true;
    },
    HideDetails() {
      this.showDetails = false;
    },
    getPartnerInfo() {
      partnerService.getPartnerInfo().then((resp) => {
        this.companycode = resp.response.currentCompanyCode;
        this.$root.isInternational =
          resp.response.countryDetail.countryCode == 100 ? false : true;
        this.partnerNumber = resp.response.partnerNumber;
      });
    },
    getEBIDDetails(c) {
      partnerService.getEIPPartnerDetails().then((resp) => {
        this.companyCode = c;
        resp.response.partnerNumber.forEach((data) => {
          this.partnerCodeValue.push({
            value: data.vendorCode,
            category: data.category,
          });
        });
        this.defaultSelection();

        // this.vendorCode = resp.response.vendorCode;
      });
    },
    defaultSelection() {
      var beforDate = new Date();
      beforDate.setDate(beforDate.getDate() - 50);
      var afterDate = new Date();
      afterDate.setDate(afterDate.getDate() + 20);
      if (beforDate && afterDate) {
        this.selectedDateRange.push(beforDate, afterDate);
        var currentMonth = new Date();
        currentMonth.setMonth(currentMonth.getMonth() - 10);
        this.disableDateBefore = currentMonth;
        var diasbleAfter = new Date();
        diasbleAfter.setMonth(diasbleAfter.getMonth() + 5);
        this.disableDateAfter = diasbleAfter;
        this.getEbidAuction(beforDate, afterDate);
      }
    },

    redirectionPage(bidDetail) {
      console.log(bidDetail);
      var partnerValue = "";
      // if (bidDetail.partnerTypeCategory) {
      //    this.partnerCodeValue.forEach(partner => {
      //     if (partner.category == bidDetail.partnerTypeCategory) {
      //     partnerValue = partner.value;
      //     }
      //    });
      //   }
      // if (partnerValue != "") {
      var partnerCode = this.EncodeUsingAES(this.partnerNumber);
      var companyCode = this.EncodeUsingAES(this.companyCode);
      var audit = sessionStorage.getItem("AuditNumber");
      var auditNumber = this.EncodeUsingAES(audit);
      var partner = this.EncodeUsingAES(bidDetail.partnerType);
      var source = this.EncodeUsingAES("Partner");
      if (partnerCode && companyCode && auditNumber) {
        window.location = this.redirectUrl(
          partnerCode,
          companyCode,
          auditNumber,
          source,
          partner
        );
      }
      // }
    },
    redirectUrl(partnerCode, companyCode, AuditNumber, source, partner) {
      return `${process.env.VUE_APP_ESOURCING_REDIRECT_URL}/?RefId=${partnerCode}&Company=${companyCode}&AuditNo=${AuditNumber}&Source=${source}&PartnerType=${partner}&URL=eSourcingPartnersUI%2Fbiddersquote&ReturnURL=${window.location.href}`;
    },
    EncodeUsingAES(value) {
      var CryptoJS = require("crypto-js");
      if (value === undefined || value === null) {
        return "";
      } else {
        const keys = atob(process.env.VUE_APP_E_4);
        const key = CryptoJS.enc.Utf8.parse(keys);
        const vectorIV = CryptoJS.enc.Utf8.parse(keys);
        const encrypted = CryptoJS.AES.encrypt(
          CryptoJS.enc.Utf8.parse(value.toString()),
          key,
          {
            keySize: 128 / 8,
            iv: vectorIV,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
          }
        );
        return encrypted.toString();
      }
    },
    DecodeUsingAES(value) {
      var CryptoJS = require("crypto-js");
      if (value === undefined || value === null) {
        return "";
      } else {
        try {
          const keys = atob(process.env.VUE_APP_E_4);
          const key = CryptoJS.enc.Utf8.parse(keys);
          const vectorIV = CryptoJS.enc.Utf8.parse(keys);
          const decrypted = CryptoJS.AES.decrypt(value, key, {
            keySize: 128 / 8,
            iv: vectorIV,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
          });
          return decrypted.toString(CryptoJS.enc.Utf8);
        } catch (e) {
          throw e;
        }
      }
    },
  },
};
</script>
<style scoped>
.auction-title {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 24px !important;
  font-weight: bold !important;
}
.tab_style:focus {
  outline: none !important;
}
.selected-number-list {
  border: solid 1px #1579ab;
  margin-left: 10px;
  padding: 1px 5px 1px 5px !important;
  font-size: 12px;
  color: #1579ab;
  background-color: #ffffff;
}
.nav-link.active > .selected-number-list {
  border: solid 1px #1579ab;
  background-color: #1579ab;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  color: #ffffff;
}
.nav-link.active > .selected-number-list {
  border: solid 1px #1579ab;
  background-color: #1579ab;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  color: #ffffff;
}
.Ebid-value {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px !important;
}
.table-bg {
  background-color: #6192b1 !important;
  border-color: #6192b1 !important;
}
.text-heading {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 20px !important;
  font-weight: bold !important;
}
.link-viewDetails {
  text-decoration: underline;
  font-size: 12px;
}
.Ebid-card {
  /* margin-right: 2px !important; */
  border-radius: 4px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
}
</style>
<style>
.request-navbar > div > ul > li > .nav-link.active {
  background-color: #f8f8f8 !important;
  border-color: #f8f8f8 !important;
  border-bottom: 4px solid #1367a3 !important;
  -webkit-transition-property: width; /* Safari */
  -webkit-transition-duration: 0.5s; /* Safari */
  -webkit-transition-delay: 2s; /* Safari */
  transition-property: width;
  transition-duration: 5s;
  transition-delay: 5s;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px !important;
  font-weight: bold !important;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: normal;
  color: #333333 !important;
}
.request-navbar > div > ul > li > .nav-link:hover {
  border-color: #f8f8f8 !important;
  background-color: #f8f8f8 !important;
}
.request-navbar > div > ul > li > .nav-link.active:hover {
  border-bottom: 4px solid #1367a3 !important;
  background-color: #f8f8f8 !important;
}
.card-header > ul > li > a {
  color: #333333;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: normal;
}
.card-header {
  padding: 0.75rem 22px;
  margin-bottom: 0;
  background: #f8f8f8 !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125) !important;
}
/* .Ebid-card {
  width: 100% !important;
}
@media (max-width: 1440px) {
  .Ebid-card {
    width: 0% !important;
    color: red;
  }
} */
</style>


